import { useMemo } from 'react';
import { useQuery, registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
export const FetchSiteSettingsQueryName = 'fetchSiteSettings';
const SiteSettingsQuery = registerQuery({
  fieldName: FetchSiteSettingsQueryName,
  fetcher: () => http.get(`content-settings/v1/site-settings/by-portal-id/${PortalIdParser.get()}`)
});
const useFetchSiteSettings = ({
  skip = false
}) => {
  const {
    loading,
    error,
    data
  } = useQuery(SiteSettingsQuery, {
    skip
  });
  const siteSettings = data === null || data === void 0 ? void 0 : data.fetchSiteSettings;
  return useMemo(() => ({
    loading,
    error,
    siteSettings
  }), [loading, error, siteSettings]);
};
export default useFetchSiteSettings;